import { createAsyncThunk } from '@reduxjs/toolkit';
import moment from 'moment';

export const fetchPrevious24HoursData = createAsyncThunk<
	FetchPrevious24HoursDataResult,
	FetchPrevious24HoursDataPayload,
	{ rejectValue: string }
>(
	'detectionStatus/fetchPrevious24HoursData',
	async ({ api, accountId }, { rejectWithValue }) => {
		try {
			const detectionsbeforeDate = await api.getAccountESFeeds(
				accountId,
				moment().subtract(2, 'days').toDate(),
				moment().subtract(1, 'days').toDate(),
				'',
				'',
				[],
				1,
				25,
				'',
				'desc',
				'Open',
			);

			return {
				detectionsbeforeDateCount: detectionsbeforeDate.totalCount,
			};
		} catch (error) {
			const message =
				error instanceof Error
					? error.message
					: 'An unexpected error occurred while fetching previous 24 hours data';
			return rejectWithValue(message);
		}
	},
);

type FetchPrevious24HoursDataPayload = {
	api: any;
	accountId: string;
};

type FetchPrevious24HoursDataResult = {
	detectionsbeforeDateCount: number;
};
